import { GetServerSideProps } from 'next';
import Link from 'next/link';
import { parseCookies } from 'nookies';
import { FormEvent } from 'react';
import { useState } from 'react';
import { AiOutlineCheck, AiOutlineClose, AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import InputMask from 'react-input-mask';
import { toast, ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import { ReCAPTCHA } from 'components/ReCAPTCHA';
import ModalRegistration from 'components/ModalRegistration';
import { useAuth } from 'contexts/AuthContext';
import { ReCAPTCHAProvider, useReCAPTCHA } from 'contexts/ReCAPTCHAContext';
import { validateEmail } from 'utils/emailValidation';
import { formattedCPF } from 'utils/validFieldCard';

export default function LoginPage() {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);
  const [cpf, setCpf] = useState('');
  const [errorCPFCNPJ, setErrorCPFCNPJ] = useState<boolean>(false);
  const [confirmEmail, setConfirmEmail] = useState<string>('');
  const [confirmEmailError, setConfirmEmailError] = useState<string>('');
  const [emailError, setEmailError] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [errorConfirmPassword, setErrorConfirmPassword] = useState<string>('');
  const [passwordError, setPasswordError] = useState(false);
  const [isCheckTermsConditions, setIsCheckTermsConditions] = useState<boolean>(false);
  const [optOutEmail, setOptOutEmail] = useState<boolean>(false);
  const [messageErrorPassword, setMessageErrorPassword] = useState<string>('');
  const { handleVerifyRecaptcha, recaptcha, refreshRecaptcha, setRefreshRecaptcha } = useReCAPTCHA();
  const [typeInputPassword, setTypeInputPassword] = useState<'password' | 'text'>('password');
  const [typeInputConfirmPassword, setTypeInputConfirmPassword] = useState<'password' | 'text'>('password');

  const [isMother, setIsMother] = useState(false);

  const [typePerson, setTypePerson] = useState<string>('CPF');
  const [firstName, lastName] = name.split(' ').length > 1 ? [name.split(' ')[0], name.split(' ').slice(1).join(' ')] : [name, ''];

  const [showModal, setShowModal] = useState(false);

  const handleChangeDocumentType = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    if (inputValue) {
      setErrorCPFCNPJ(false);
    }
    setCpf(regexNumero(inputValue));

    // if (inputValue.length <= 11) {
    //   setCpf(inputValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"));
    // } else {
    //   setCpf(inputValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"));
    //   setTypePerson("CNPJ")
    // }
  };

  const regexLetters = (e: any) => {
    return e.target.value.replace(/[^a-zA-Zà-ùÀ-Ù ]/g, '');
  };

  const regexNumero = (string: any) => {
    return string.replace(/[^0-9]/g, '');
  };

  const { signUp, loading } = useAuth();

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (name.length < 3) {
      toast.error('Digite um nome válido!');
      setNameError(true);
    }
    if (!firstName || lastName === '') {
      toast.error('Digite o nome completo!');
      setNameError(true);
    }
    if (password.length <= 7) {
      setPasswordError(true);
      toast.error('A senha precisa ter pelo menos 8 caracteres!');
    }

    if (!validateEmail(email)) {
      setEmailError(true);
      toast.error('Digite um email válido!');
    }

    if (email !== confirmEmail) {
      toast.error('Os emails não coincidem!');
      return;
    }

    if (phone.length !== 10 && phone.length !== 11) {
      setPhoneError(true);
      toast.error('Digite um telefone válido!');
      return
    };

    if (!cpf.length) {
      toast.error('É necessário informar o cpf.');
      setErrorCPFCNPJ(true);
      return;
    }

    if (password !== confirmPassword) {
      toast.error('As senhas devem ser iguais.');
      return;
    }

    if (!isCheckTermsConditions) {
      toast.error('É necessário aceitar os termos e condições');
      return;
    }

    if (messageErrorPassword.length) {
      toast.error(messageErrorPassword);
      return;
    }

    if (name.length < 3 || !validateEmail(email) || password.length < 8) return;

    const data = {
      name,
      email,
      password,
      recaptcha,
      cpf,
      phone,
      optOutEmail,
    };

    await signUp(data);
    setRefreshRecaptcha(Date.now());
    setShowModal(false);
  }


  function handlePaste(event: React.ClipboardEvent<HTMLInputElement>) {
    event.preventDefault(); // desativa copiar e colar
  }

  return (
    <ReCAPTCHAProvider>
      <Wrapper>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 9999999 }}
        />
        <Content>
          <Left>
            <img src="/login-left.png" alt="background" />
          </Left>
          <Right>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              <Header>
                <img src="/Logo.svg" alt="logo" />
              </Header>

              <Group error={nameError}>
                <input
                  type={'text'}
                  name="nome"
                  placeholder="Nome completo"
                  value={name}
                  onChange={(e) => {
                    setName(regexLetters(e));
                    if (name.length > 3) setNameError(false);
                  }}
                />
              </Group>

              <Group error={emailError}>
                <input
                  type="email"
                  placeholder="E-mail"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (validateEmail(email)) setEmailError(false);
                  }}
                />
              </Group>
              <Group error={emailError}>
                <input
                  type="email"
                  onPaste={handlePaste}
                  placeholder="Confirme seu e-mail"
                  onChange={(e) => {
                    setConfirmEmail(e.target.value);
                    if (!e.target.value.length) setConfirmEmailError('Preenchimento obrigatorio!');
                    else if (e.target.value !== email) setConfirmEmailError('Os e-mails não coincidem!');
                    else setConfirmEmailError('');
                  }}
                />
                {confirmEmailError.length ? <AlertMessage>{confirmEmailError}</AlertMessage> : null}
              </Group>

              <Group error={phoneError}>
                <input type="tel"
                  placeholder="Telefone"
                  value={phone}
                  maxLength={11}
                  onChange={(e) => {
                    setPhone(regexNumero(e.target.value));
                    if (phone.length === 10 || phone.length === 11) setPhoneError(false);
                  }}
                />
              </Group>

              <Group error={errorCPFCNPJ}>
                <input
                  type={typePerson}
                  placeholder="CPF"
                  maxLength={typePerson === 'CPF' ? 11 : 14}
                  minLength={typePerson === 'CPF' ? 11 : 14}
                  value={formattedCPF(cpf)}
                  onChange={handleChangeDocumentType}
                />
              </Group>

              <Group error={passwordError} style={{ position: 'relative' }}>
                <input
                  type={typeInputPassword}
                  placeholder="Senha"
                  onChange={(e) => {
                    const validatePassword = /(?=.*[}{%&$@ç!#*,.^?~=+\-/*\-+.|])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[0-9]).{8,}/gm;

                    setPassword(e.target.value);
                    if (e.target.value.length && !validatePassword.test(e.target.value))
                      setMessageErrorPassword(
                        'A senha deve possuir pelo menos 8 digitos, letras maíusculas, minúsculas e caracteres especiais.',
                      );
                    else setMessageErrorPassword('');
                    if (password.length > 8) setPasswordError(false);
                  }}
                />
                {typeInputPassword === 'text' ? (
                  <AiOutlineEyeInvisible
                    style={{ position: 'absolute', right: '15px', top: '10px', cursor: 'pointer' }}
                    size={25}
                    onClick={() => setTypeInputPassword('password')}
                  />
                ) : (
                  <AiOutlineEye
                    size={25}
                    style={{ position: 'absolute', right: '15px', top: '10px', cursor: 'pointer' }}
                    onClick={() => setTypeInputPassword('text')}
                  />
                )}
                {password.length > 0 && (
                  <ContainerMessageErrorPassword>
                    <div className="lineAlert">
                      {password.length < 8 ? <AiOutlineClose size={14} fill="#174F68" /> : <AiOutlineCheck size={14} fill="#5cc9aa" />}
                      <span className={password.length >= 8 ? 'sucess' : 'error'}>8 caracteres contendo</span>
                    </div>
                    <div className="lineAlert">
                      {/(?=.*[A-Z])/.test(password) ? (
                        <AiOutlineCheck size={14} fill="#5cc9aa" />
                      ) : (
                        <AiOutlineClose size={14} fill="#174F68" />
                      )}
                      <span className={/(?=.*[A-Z])/.test(password) ? 'sucess' : 'error'}>1 Caractere maiúsculo</span>
                    </div>
                    <div className="lineAlert">
                      {/(?=.*[a-z])/.test(password) ? (
                        <AiOutlineCheck size={14} fill="#5cc9aa" />
                      ) : (
                        <AiOutlineClose size={14} fill="#174F68" />
                      )}
                      <span className={/(?=.*[a-z])/.test(password) ? 'sucess' : 'error'}>1 Caractere minúsculo</span>
                    </div>
                    <div className="lineAlert">
                      {/(?=.*\d)/.test(password) ? (
                        <AiOutlineCheck size={14} fill="#5cc9aa" />
                      ) : (
                        <AiOutlineClose size={14} fill="#174F68" />
                      )}
                      <span className={/(?=.*\d)/.test(password) ? 'sucess' : 'error'}>1 Caractere numérico</span>
                    </div>
                    <div className="lineAlert">
                      {/[^a-zA-Z 0-9]+/g.test(password) ? (
                        <AiOutlineCheck size={14} fill="#5cc9aa" />
                      ) : (
                        <AiOutlineClose size={14} fill="#174F68" />
                      )}
                      <span className={/[^a-zA-Z 0-9]+/g.test(password) ? 'sucess' : 'error'}>
                        1 Caractere especial (são aceitos: ?!@#$%^)
                      </span>
                    </div>
                  </ContainerMessageErrorPassword>
                )}
              </Group>
              <Group error={passwordError} style={{ position: 'relative' }}>
                <input
                  onPaste={handlePaste}
                  type={typeInputConfirmPassword}
                  placeholder="Confirme sua senha"
                  onChange={(e: any) => {
                    setConfirmPassword(e.target.value);
                    if (!e.target.value.length) setErrorConfirmPassword('Preenchimento obrigatorio!');
                    else if (e.target.value !== password) setErrorConfirmPassword('As senhas não coincidem!');
                    else setErrorConfirmPassword('');
                  }}
                />
                {typeInputConfirmPassword === 'text' ? (
                  <AiOutlineEyeInvisible
                    style={{ position: 'absolute', right: '15px', top: '10px', cursor: 'pointer' }}
                    size={25}
                    onClick={() => setTypeInputConfirmPassword('password')}
                  />
                ) : (
                  <AiOutlineEye
                    size={25}
                    style={{ position: 'absolute', right: '15px', top: '10px', cursor: 'pointer' }}
                    onClick={() => setTypeInputConfirmPassword('text')}
                  />
                )}
                {errorConfirmPassword.length ? <AlertMessage>{errorConfirmPassword}</AlertMessage> : null}
              </Group>

              <Select>
                <label>É mãe?</label>
                <select
                  value={isMother ? 'true' : 'false'}
                  onChange={(e) => {
                    console.log('Selected value:', e.target.value);
                    console.log('Parsed value:', e.target.value === 'true');
                    setIsMother(e.target.value === 'true');
                  }}
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </select>
              </Select>

              <Checkbox>
                <input type="checkbox" name="" id="" onClick={() => setIsCheckTermsConditions(!isCheckTermsConditions)} />
                <a href="/termos-e-condicoes">Aceito os termos e condições</a>
              </Checkbox>

              <Checkbox>
                <input type="checkbox" name="" id="" onClick={() => setOptOutEmail(!optOutEmail)} />
                <span>Marque essa opção para não receber comunicações por e-mail da Meu Nascimento</span>
              </Checkbox>

              <ReCAPTCHA onVerify={handleVerifyRecaptcha} refreshReCaptcha={refreshRecaptcha} />
              <Button type="submit">{loading ? 'Carregando' : 'Cadastrar'}</Button>
              <Cadastrese>
                <Link href="/login">Já tem uma conta ? Clique aqui</Link>
              </Cadastrese>
            </Form>
          </Right>
        </Content>
      </Wrapper>
      <ModalRegistration
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleSubmit={handleSubmit}
      />
    </ReCAPTCHAProvider>
  );
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const cookies = parseCookies(ctx);

  if (cookies['meunascimento.token']) {
    return {
      redirect: {
        destination: '/profile/user',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
};

const Wrapper = styled.div``;
const Content = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  background: #fbf9ed;

  justify-content: space-between;

  @media (max-width: 766px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: relative;
  height: 100vh;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 2px 25px 25px 2px;

  img {
    max-width: 101%;
    object-fit: cover;
  }

  @media (max-width: 1000px) {
    display: none;
  }
`;

const Right = styled.div`
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;

  margin-right: 7rem;

  @media (max-width: 766px) {
    height: 100vh;
    width: 100vw;
  }
`;

const Form = styled.form`
  display: flex;
  gap: 8px;
  flex-direction: column;

  @media (max-width: 390px) {
    width: 74vw;
  }

  @media (max-width: 766px) {
    width: 74vw;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 10px;

  img {
    display: block;
  }

  @media (max-width: 766px) {
    img {
      margin-top: 1rem;
      width: 80%;
    }
  }
`;

interface IInputProps {
  error: boolean;
}

const Group = styled.div<IInputProps>`
  display: flex;
  flex-direction: column;
  gap: 8px;

  input {
    width: 100%;
    font-size: 1.5rem;
    background: #fbf9ed;
    padding: 1rem;
    border: ${({ error }) => (error ? '2px solid #174F68' : '2px solid #174F68')};
    border-radius: 10px;
  }

  input::placeholder {
    font-size: 15px;
    color: #222222;
    font-weight: 500;
  }

  input:hover {
    border: solid 2px #797bb0;
    color: #0076a0;
  }

  input:focus {
    font-size: 14px;
    border: solid 2px #174f68;
    color: #222222;
  }

  input:focus,
  select:focus {
    box-shadow: 0.3px 0.3px 0.3px;
    outline: 0;
  }

  img {
    position: absolute;
    margin: 10px 20px;
  }

  a {
    font-size: 15px;
    color: #174f68;
    float: right;
    transition: all 0.5s;
  }

  a {
    margin: 2.4rem;
  }

  @media (max-width: 766px) {
    a {
      font-size: 13px;
    }
  }
`;

const Button = styled.button`
  border-radius: 10px;
  width: 100%;
  border: none;
  font-weight: 500;
  padding: 1rem 0;
  background: #174f68;
  font-size: 15px;
  color: #fff;
  cursor: pointer;
  text-transform: uppercase;
  transition: all 0.5s;

  :hover {
    opacity: 0.6;
  }
`;

const Cadastrese = styled.div`
  text-align: center;
  margin-top: 1rem;

  > a {
    font-size: 20px;
    transition: all 0.5s;
    color: #174f68;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
  }

  :hover {
    opacity: 0.5;
  }

  @media (max-width: 766px) {
    a {
      font-size: 13px;
    }
  }
`;

const Checkbox = styled.div`
  font-size: 1.5rem;
  display: flex;

  input {
    width: 1.5rem;
  }

  a {
    text-decoration: none;
    margin-left: 5px;
    color: #f09192;
  }
`;

const ContainerMessageErrorPassword = styled.div`
  background: #f5f5f5;
  border-radius: 10px;
  border: solid 1px #5cc9aa;
  position: relative;
  z-index: 9999;
  padding: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;

  .lineAlert {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
      font-size: 14px;
      color: #ddd;
      margin-left: 5px;
    }

    .error {
      color: #174f68;
    }

    .sucess {
      color: #5cc9aa;
    }
  }

  @media (max-width: 766px) {
    width: 100%;
  }
`;

const AlertMessage = styled.span`
  font-size: 12px;
  color: #174f68;
  max-width: 300px;
`;

const Select = styled.div`
  font-size: 18px;
  color: #174f68;
  font-weight: 500;
  text-decoration: none;
  margin-top: 4px;

  label {
    margin-right: 10px;
  }

  select {
    width: 16%;
    padding: 2px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
    cursor: pointer;
    outline: none;
    transition: border-color 0.3s;
  }

  @media (max-width: 766px) {
    select {
      width: 23%;
    }
  }
`;